import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import ceoImage from "../assets/4.jpg";

function Ceo() {
  return (
    <section id="ceo">
      <Box sx={{ margin: "40px 0", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          {/* Text Section */}
          <Grid item xs={12} md={6}>
            <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
              <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: "10px" }}>
                Нямдорж Бямбадорж
              </Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginBottom: "10px" }}>
                Гүйцэтгэх захирал
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: "10px" }}>
                /Хууль зүйн ухааны магистр, Бизнесийн удирдлагын магистр/
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: "10px" }}>
                Ажлын туршлага:
              </Typography>
              <ul style={{ paddingLeft: "20px", textAlign: "left" }}>
                <li>Төрийн аудитын байгууллага - Шинжээч, хуулийн зөвлөх</li>
                <li>Газрын харилцаа барилга, хот байгуулалтын газрын дарга</li>
                <li>УИХ тамгын газар - Зөвлөх</li>
                <li>Сайдын зөвлөх</li>
                <li>Хуульч, өмгөөлөгч</li>
              </ul>
            </Box>
          </Grid>

          {/* Image Section */}
          <Grid item xs={12} md={6}>
            <Box sx={{ textAlign: "center" }}>
              <img
                src={ceoImage}
                alt="CEO Picture"
                style={{
                  maxWidth: "250px", // Set a smaller max width for better responsiveness
                  borderRadius: "10px", // Add rounded corners
                  width: "100%", // Ensure responsiveness
                  height: "auto", // Maintain aspect ratio
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </section>
  );
}

export default Ceo;